import dayjs from 'dayjs';
import { cn } from '../../utils/utils';
import { Text } from '../SecondaryMarket';
import ViewReverse from '../ViewReverse';
import FooterFunctional from './index.function';

const Footer = ({ className }) => {
  const { TextWeight, isArabic, getContentKey, lastLogin } = FooterFunctional();

  return (
    <ViewReverse className={cn('justify-between items-center px-4 md:px-12 py-3', className)}>
      <Text text={`${getContentKey("last_login")} ${dayjs(lastLogin).format("DD MMM YYYY")} ${dayjs(lastLogin).format("hh:mm A")}`} weight={TextWeight.medium} />
      <Text text={getContentKey("copyright")} weight={TextWeight.medium} align={isArabic ? 'text-left' : 'text-right'} />
    </ViewReverse>
  );
};

export default Footer;
